import { Box } from '@mui/material'

export default function DividerHorizontal() {
    return (
        <Box sx={{ height: '5px', mt: 4, mb: 4, background: 'linear-gradient(to right, #6728AF 50%, #84858a 50%)' }}></Box>
    )
}
